import { motion, useInView, useReducedMotion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";

// Scroll-linked ambient glow: drifts in from its anchored side and breathes slowly.
export default function AmbientGlow({ color, className = "", opacity = 0.05, side = "left" }) {
    const reduced = useReducedMotion();
    const ref = useRef(null);
    const inView = useInView(ref, { margin: "300px" });
    const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
    const drift = useTransform(scrollYProgress, [0, 1], side === "left" ? [-70, 70] : [70, -70]);

    return (
        <motion.div
            ref={ref}
            aria-hidden="true"
            style={reduced ? {} : { x: drift }}
            className={`pointer-events-none absolute ${className}`}
        >
            <motion.div
                animate={reduced || !inView ? {} : { scale: [1, 1.08, 1] }}
                transition={{ duration: 10, repeat: Infinity, ease: "easeInOut" }}
                className="h-full w-full rounded-full"
                style={{ background: `radial-gradient(circle, ${color} 0%, transparent 65%)`, opacity }}
            />
        </motion.div>
    );
}
